import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "./components/ui/badge";
import { Button } from "./components/ui/button";
import { NdaLegalBox } from "./components/NdaMention";
import { CheckCircle2, FileText, ArrowRight, Trophy } from "lucide-react";

// ===============================================================
// MGB SCHOOL — Page Bac Pro OTM
// ===============================================================
// 💳 Paiement PayPal / CB via /paiement/:code
//    fourni par MGB School lorsque les liens seront disponibles.
// ===============================================================

const FORMATIONS_OTM = [
  {
    id: "otm-1",
    emoji: "🚛",
    title: "Maîtriser le Transport Routier",
    public: "Bac Pro OTM · BTS GTLA · Reconversion",
    price: 79,
    points: [
      "Lettre de voiture CMR",
      "Réglementation temps de conduite",
      "Exercices corrigés inclus",
    ],
    documents: [
      "Lettre de voiture",
      "Bon de livraison",
      "Planning conducteur",
      "Fiche incident",
    ],
  },
  {
    id: "otm-2",
    emoji: "🚢",
    title: "Transport Maritime & Conteneurs",
    public: "Bac Pro OTM · Commerce international",
    price: 97,
    points: [
      "Bill of Lading",
      "Incoterms maritimes",
      "Cas pratique Chine → France",
    ],
    documents: [
      "Bill of Lading",
      "Booking",
      "Packing list",
      "Facture export",
    ],
  },
  {
    id: "otm-3",
    emoji: "✈️",
    title: "Transport Aérien de Marchandises",
    public: "Bac Pro OTM · Logisticiens",
    price: 89,
    points: [
      "Air Waybill (AWB)",
      "Calcul poids taxable",
      "Cas export luxe Paris → Dubaï",
    ],
    documents: ["AWB", "Fiche sûreté", "Bon expédition"],
  },
  {
    id: "otm-4",
    emoji: "🚆",
    title: "Transport Ferroviaire",
    public: "Bac Pro OTM · Industrie",
    price: 69,
    points: [
      "Transport combiné rail/route",
      "Avantages écologiques",
      "Comparaison rail vs route",
    ],
    documents: [
      "Lettre de voiture CIM",
      "Planning chargement",
      "Suivi multimodal",
    ],
  },
  {
    id: "otm-5",
    emoji: "🌍",
    title: "Transport Multimodal & International",
    public: "Bac Pro OTM · Commerce international",
    price: 149,
    points: [
      "Chaîne logistique internationale complète",
      "Incoterms 2020",
      "Gestion risques et douane",
    ],
    documents: [
      "Document multimodal",
      "Déclaration douanière",
      "EUR1",
      "Carnet ATA",
    ],
  },
  {
    id: "otm-6",
    emoji: "📦",
    title: "Supply Chain & Logistique Moderne",
    public: "Bac Pro OTM · BTS GTLA",
    price: 119,
    points: [
      "Méthodes ABC FIFO LIFO",
      "KPIs logistiques",
      "WMS TMS et outils digitaux",
    ],
    documents: [
      "Fiche stock",
      "Tableau KPI",
      "Bon de réception",
      "Inventaire",
    ],
  },
  {
    id: "otm-7",
    emoji: "📑",
    title: "Douane, Incoterms & Documents",
    public: "Bac Pro OTM · Assistants export",
    price: 129,
    points: [
      "Les 11 Incoterms 2020",
      "DAU douanier",
      "Sécurisation documentaire",
    ],
    documents: [
      "DAU",
      "Facture export",
      "EUR1",
      "Packing list",
      "Documents transit",
    ],
  },
  {
    id: "otm-8",
    emoji: "💻",
    title: "TMS, WMS & Outils Digitaux",
    public: "Bac Pro OTM · Professionnels digitalisation",
    price: 149,
    points: [
      "TMS et WMS opérationnels",
      "10 KPIs transport",
      "IA et supply chain digitale",
    ],
    documents: [
      "Tableau de bord",
      "KPI transport",
      "Planning digital",
      "Dashboard",
    ],
  },
];

const PACK_EXPERT_LINK = "/formations/pack-bac-pro-otm";


const BacProOtmPage = () => {
  const scrollToFormations = () => {
    const el = document.getElementById("otm-formations");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="pt-20 md:pt-24" data-testid="otm-page">
      {/* ============ HERO ============ */}
      <section
        className="py-20 md:py-28 relative overflow-hidden"
        style={{
          background:
            "linear-gradient(135deg, #003087 0%, #0046C7 60%, #2196F3 100%)",
        }}
      >
        <div className="container-custom text-center relative z-10">
          <Badge className="bg-[#F07B1D] text-white font-bold mb-6 text-sm">
            📚 Réussite Bac Pro OTM · BTS GTLA
          </Badge>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
            Réussir le Bac Pro OTM
          </h1>
          <p className="text-lg md:text-xl text-white/85 max-w-3xl mx-auto mb-10 leading-relaxed">
            8 formations courtes avec exercices corrigés, documents
            professionnels et simulations métier. Transport routier, maritime,
            aérien, ferroviaire, logistique, douane et supply chain.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={scrollToFormations}
              className="bg-[#F07B1D] hover:bg-[#d96a14] text-white font-bold px-8 py-6 text-base shadow-lg"
              data-testid="otm-hero-cta-formations"
            >
              Voir les formations <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <a href="#otm-pack-expert">
              <Button
                variant="outline"
                className="border-2 border-white bg-transparent text-white hover:bg-white hover:text-[#003087] font-bold px-8 py-6 text-base"
                data-testid="otm-hero-cta-pack"
              >
                <Trophy className="w-5 h-5 mr-2" /> Pack complet 299€
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* ============ BANDEAU SOUS HERO ============ */}
      <section className="bg-white py-6 border-b border-gray-100">
        <div className="container-custom">
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm md:text-base text-gray-700">
            <span className="flex items-center gap-2">🎓 Bac Pro OTM</span>
            <span className="text-gray-300">·</span>
            <span className="flex items-center gap-2">📚 BTS GTLA</span>
            <span className="text-gray-300">·</span>
            <span className="flex items-center gap-2">🔄 Reconversion</span>
            <span className="text-gray-300">·</span>
            <span className="flex items-center gap-2">📝 Exercices corrigés</span>
            <span className="text-gray-300">·</span>
            <span className="flex items-center gap-2">💳 PayPal · CB</span>
            <span className="text-gray-300">·</span>
            <span className="flex items-center gap-2">📥 Accès immédiat</span>
          </div>
        </div>
      </section>

      {/* ============ CATALOGUE 8 FORMATIONS ============ */}
      <section id="otm-formations" className="section-padding bg-[#F5F5F5]">
        <div className="container-custom">
          <div className="text-center mb-12">
            <Badge className="bg-[#2196F3] text-white font-bold mb-4">
              Catalogue OTM
            </Badge>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#003087] mb-3">
              8 formations courtes & opérationnelles
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Chaque formation inclut des exercices corrigés et les documents
              professionnels du métier — prêts à utiliser.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {FORMATIONS_OTM.map((f) => (
              <article
                key={f.id}
                className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden flex flex-col hover:shadow-lg transition-shadow"
                data-testid={`otm-card-${f.id}`}
              >
                <div className="p-6 flex-1 flex flex-col">
                  <div className="text-4xl mb-3">{f.emoji}</div>
                  <h3 className="font-heading text-lg font-bold text-[#003087] mb-2 leading-snug">
                    {f.title}
                  </h3>
                  <p className="text-xs text-gray-500 mb-4 italic">
                    {f.public}
                  </p>

                  <div className="mb-4">
                    <span className="inline-block text-xs font-bold uppercase tracking-wider text-[#F07B1D] bg-[#F07B1D]/10 px-3 py-1 rounded-full" data-testid={`otm-included-${f.id}`}>
                      Inclus dans le Pack à 299 €
                    </span>
                  </div>

                  <ul className="space-y-2 mb-4">
                    {f.points.map((p) => (
                      <li
                        key={p}
                        className="flex items-start gap-2 text-sm text-gray-700"
                      >
                        <CheckCircle2 className="w-4 h-4 text-[#2196F3] flex-shrink-0 mt-0.5" />
                        <span>{p}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="bg-[#F5F5F5] rounded-lg p-3 mb-5 mt-auto">
                    <div className="flex items-center gap-2 text-xs font-bold text-[#003087] mb-1.5">
                      <FileText className="w-3.5 h-3.5" />
                      Documents inclus
                    </div>
                    <p className="text-xs text-gray-600 leading-relaxed">
                      {f.documents.join(" · ")}
                    </p>
                  </div>

                  <a href="#otm-pack-expert" data-testid={`otm-pack-link-${f.id}`}>
                    <Button className="w-full bg-[#003087] hover:bg-[#00255f] text-white font-bold py-5">
                      Voir le Pack complet — 299 €
                    </Button>
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ============ PACK EXPERT TRANSPORT (juste avant footer) ============ */}
      <section id="otm-pack-expert" className="py-16 bg-white">
        <div className="container-custom">
          <div
            className="rounded-2xl p-8 md:p-12 w-full"
            style={{
              background:
                "linear-gradient(135deg, #003087 0%, #1E3A8A 50%, #2855B5 100%)",
              border: "2px solid #F59E0B",
              borderRadius: "16px",
              boxShadow:
                "0 0 0 1px rgba(245, 158, 11, 0.25), 0 20px 60px rgba(0, 48, 135, 0.25)",
            }}
            data-testid="otm-pack-expert"
          >
            {/* Badge centré */}
            <div className="text-center mb-6">
              <span
                className="inline-block font-bold px-5 py-2 rounded-full text-sm text-white"
                style={{ background: "#F59E0B" }}
              >
                🏆 OFFRE COMPLÈTE — 8 MODULES + 6 BONUS
              </span>
            </div>

            {/* Titre */}
            <h2
              className="text-center text-white font-bold mb-4"
              style={{ fontSize: "28px", lineHeight: "1.2" }}
            >
              Expert Transport &amp; Logistique — La Formation Complète
            </h2>

            {/* Sous-titre */}
            <p className="text-center text-white/80 max-w-3xl mx-auto mb-10 text-base leading-relaxed">
              Les 8 formations + 6 bonus pour maîtriser tous les modes de
              transport, la logistique, la douane et la supply chain
            </p>

            {/* Grille 2 colonnes */}
            <div className="grid sm:grid-cols-2 gap-x-8 gap-y-3 max-w-4xl mx-auto mb-10 text-white text-sm md:text-base">
              {[
                "✅ 🚛 Transport Routier de Marchandises",
                "✅ 🚢 Transport Maritime et Conteneurs",
                "✅ ✈️ Transport Aérien de Marchandises",
                "✅ 🚆 Ferroviaire, Multimodal & International",
                "✅ 📈 Amélioration de la performance & tableaux de bord",
                "✅ 📦 Supply Chain et Logistique Moderne",
                "✅ 📑 Douane, Incoterms & Documents",
                "✅ 💻 TMS / WMS & Outils numériques",
                "🎁 Pack Documents Professionnels PDF et Word",
                "🎁 Pack Exercices Corrigés Bac Pro OTM",
                "✅ Quiz d'auto-évaluation corrigés dans chaque module",
                "🎁 Simulations agent d'exploitation",
                "🎁 Pack Emploi et Alternance CV LM entretien",
                "🎁 Fiches mémo & révision rapide",
                "🏆 Certificat de fin de formation MGB School",
                "📚 Guide Méthodologie examen Bac Pro OTM",
              ].map((line) => (
                <div key={line} className="flex items-start gap-2 leading-snug">
                  <span>{line}</span>
                </div>
              ))}
            </div>

            {/* Bloc prix */}
            <div className="text-center mb-8">
              <p className="text-white/70 text-base mb-2">
                8 modules + 6 bonus + certificat
              </p>
              <p
                className="font-extrabold leading-none mb-3"
                style={{ color: "#F59E0B", fontSize: "56px" }}
              >
                299 €
              </p>
              <p
                className="font-bold mb-2"
                style={{ color: "#22C55E" }}
              >
                Paiement unique, sans abonnement
              </p>
              <p className="text-white/70 text-sm">
                Paiement unique · Accès immédiat · PDF inclus
              </p>
            </div>

            {/* Bouton CTA pleine largeur */}
            <a
              href={PACK_EXPERT_LINK}
              data-testid="otm-pack-expert-buy"
              className="block"
            >
              <Button
                className="w-full font-bold text-base text-[#003087] hover:brightness-110"
                style={{ background: "#F59E0B", height: "56px" }}
              >
                🏆 Prendre la Formation Complète — 299 €
              </Button>
            </a>

            {/* Note sous bouton */}
            <p className="text-center text-white/70 text-xs md:text-sm mt-5 leading-relaxed">
              🔒 Paiement sécurisé PayPal · CB · Visa · Mastercard · Accès PDF
              immédiat · Satisfait ou remboursé 14 jours
            </p>
          </div>

          {/* Lien contact discret */}
          <div className="text-center mt-10">
            <Link
              to="/contact"
              className="text-[#003087] hover:text-[#F07B1D] underline text-sm font-medium"
            >
              Une question sur le Bac Pro OTM ? Contactez-nous
            </Link>
          </div>
        </div>
      </section>

      {/* ============ FAQ ANTI-OBJECTIONS — Pack Expert 299 € ============ */}
      <section className="py-16 bg-[#F5F7FA]" data-testid="otm-faq">
        <div className="container-custom max-w-3xl">
          <div className="text-center mb-10">
            <span className="inline-block bg-[#003087] text-white text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full mb-3">
              FAQ
            </span>
            <h2 className="font-heading text-3xl font-bold text-[#003087]">
              Vos questions sur le Pack Expert Transport
            </h2>
          </div>
          <div className="space-y-4">
            {[
              {
                q: "Pourquoi cette formation vaut 299 € ?",
                a: "Le Pack Bac Pro OTM regroupe les 8 modules transport (routier, maritime, aérien, ferroviaire/multimodal/international, supply chain, douane & Incoterms, TMS/WMS, performance & tableaux de bord), chacun avec son quiz corrigé, plus 6 bonus exclusifs (documents pro, exercices type examen, fiches mémo, simulations, emploi & alternance, méthodologie) et le certificat MGB School. Un paiement unique de 299 € pour un accès immédiat et illimité à tout.",
              },
              {
                q: "Qui a écrit ces formations ?",
                a: "Maryse GALITA — 20 ans chef d'entreprise transport (Jet Courses · Guadeloupe et Orly), agrément douane reconnu en Europe, enseignante Bac Pro OTM. Elle a vécu les lettres de voiture, Bill of Lading, DAU, Incoterms avant de les enseigner.",
              },
              {
                q: "Est-ce adapté à un élève en Bac Pro OTM ?",
                a: "Oui, c'est conçu pour ça. Chaque module reprend les exigences du référentiel Bac Pro OTM et du BTS GTLA, avec les documents professionnels réels utilisés en entreprise. Les exercices corrigés permettent de réviser sur les supports attendus aux examens.",
              },
              {
                q: "Comment savoir si le contenu est de qualité avant d'acheter ?",
                a: "Chaque carte formation ci-dessus liste précisément les compétences abordées et les documents inclus (CMR, AWB, DAU, Incoterms…). Si vous avez un doute, écrivez à contact@mgbschool.fr — on vous envoie un extrait de slide.",
              },
              {
                q: "Je peux me faire rembourser ?",
                a: "Oui. Vous disposez de 14 jours pour demander un remboursement complet à contact@mgbschool.fr — sans justification, sans pénalité.",
              },
              {
                q: "Est-ce que MGB School est un vrai organisme de formation ?",
                a: "Oui. MGB School est un organisme de formation déclaré (SASU, SIRET 999 673 635 00010 — NDA 11757727775, déclaration d'activité enregistrée auprès du préfet de la région Île-de-France ; cet enregistrement ne vaut pas agrément de l'État), dispensant des formations conformes au Code du travail. Formatrice professionnelle certifiée.",
              },
            ].map((item) => (
              <details
                key={item.q}
                className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden"
              >
                <summary
                  className="cursor-pointer px-5 py-4 font-bold text-[#003087] hover:bg-gray-50 transition-colors text-sm md:text-base list-none flex items-center justify-between gap-3"
                  style={{ userSelect: "none" }}
                >
                  <span>{item.q}</span>
                  <span className="text-[#F07B1D] text-lg flex-shrink-0">+</span>
                </summary>
                <div className="px-5 pb-4 text-sm text-gray-700 leading-relaxed">
                  {item.a}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
      <div className="container-custom max-w-3xl py-10"><NdaLegalBox /></div>
    </div>
  );
};

export default BacProOtmPage;
